import Vue from "vue";
import Vuex from "vuex";

import axios from 'axios';

import vocabularyService from "@/services/vocabulary.js";
import { randomString } from "../services/helpers";
const helpers = require("@/services/helpers.js");
const constants = require("@/constants.js");
const gameSettings = require("@/gameSettings.js");

Vue.use(Vuex);

function newGame(state) {
  let firstIdx = 0; // state.gameCount == 0 ? 2 : 0; // TODO REMOVE UGLY HACK!!!
  let settings = gameSettings.get();

  let enabledGames = [
    {
      name: "is-to-Nfr", enabled:
        settings.game["is-to-Nfr"]
    },
    {
      name: "fr-to-Nis",
      enabled: settings.game["fr-to-Nis"]
    },
    {
      name: "is-to-fr",
      enabled: settings.game["is-to-fr"]
    },
    {
      name: "fr-to-is",
      enabled: settings.game["fr-to-is"]
    },
    { name: "path", enabled: settings.game["path"] },
    { name: "spell", enabled: settings.game["spell"] },
    {
      name: "syllables",
      enabled: settings.game["syllables"]
    },
    {
      name: "hole",
      enabled: settings.game["hole"]
    }
  ].filter(g => g.enabled).map(g => g.name);

  let games = constants.GAMES.filter(g => enabledGames.includes(g.name));

  let game =
    games[
    helpers.randomInteger(firstIdx, games.length - 1)
    ];
  state.game = game;
  state.gameSrcLang = selectLang(game.srcLang);
  state.gameTargetLang = selectLang(game.targetLang);
  state.gameAllowedErrors = game.allowedErrors;
  state.gameCount++;
}

function selectLang(commaSeparatedList) {
  let langs = commaSeparatedList.split(',');
  return randomString(langs);
}

/*async*/ function newWords(state) {

  if (state.game.name == "hole") {
    state.gameSentence = /*await*/ getSentence();
    return;
  }

  state.gameSentence = null;

  let selectedCategories = state.categories.filter((entry) => entry.selected);
  let wordsOfSelectedCategories = [];
  state.categories.forEach((entry) => {
    if (selectedCategories.length == 0 || entry.selected) {
      wordsOfSelectedCategories.push(...state.wordsOfCategory[entry.category]);
    }
  });

  let settings = gameSettings.get();
  if (settings.onlyEg) {
    wordsOfSelectedCategories = wordsOfSelectedCategories.filter((word) => {
      let src = word.is;
      return src.startsWith("ég ");
    });
  } else if (settings.onlyMultiword) {
    wordsOfSelectedCategories = wordsOfSelectedCategories.filter((word) => {
      let src = word.is;
      return src.indexOf(" ") >= 0;
    });
  }

  state.selectedWords = [];
  for (let ii = 0; ii < constants.SELECTED_WORDS_SIZE; ii++) {
    if (wordsOfSelectedCategories.length == 0) break;
    let idx = helpers.randomInteger(0, wordsOfSelectedCategories.length - 1);
    state.selectedWords.push(wordsOfSelectedCategories[idx]);
    wordsOfSelectedCategories.splice(idx, 1);
  }
  if (state.failedWord && state.selectedWords.length > 0) {
    let idx = helpers.randomInteger(0, state.selectedWords.length - 1);
    state.selectedWords[idx] = state.failedWord;
  }
}

/*async*/ function getSentence() {
  let sentences = [
    { "id": 1371, "icelandic": "\u00e9g er ekki \u00ed skapi til a\u00f0 segja honum sannleikann", "english": null, "french": "je n'ai pas envie de lui dire la v\u00e9rit\u00e9", "greynir": [{ "text": "\u00e9g", "lemma": "\u00e9g", "terminal": "pfn_et_nf", "pos": "pfn" }, { "text": "er", "lemma": "vera", "terminal": "so_0_et_p1", "pos": "so" }, { "text": "ekki", "lemma": "ekki", "terminal": "ao", "pos": "ao" }, { "text": "\u00ed", "lemma": "\u00ed", "terminal": "fs_\u00fegf", "pos": "fs" }, { "text": "skapi", "lemma": "skap", "terminal": "no_et_\u00fegf_hk", "pos": "no", "hide": true }, { "text": "til", "lemma": "til", "terminal": "fs_nh", "pos": "fs" }, { "text": "a\u00f0", "lemma": "a\u00f0", "terminal": "nhm", "pos": "nhm" }, { "text": "segja", "lemma": "segja", "terminal": "so_2_\u00fegf_\u00fef_nh", "pos": "so" }, { "text": "honum", "lemma": "hann", "terminal": "pfn_kk_et_\u00fegf", "pos": "pfn" }, { "text": "sannleikann", "lemma": "sannleiki", "terminal": "no_et_\u00fef_kk", "pos": "no" }], "dict": 1 },
    { "id": 445, "icelandic": "\u00feetta h\u00fas er ekki til s\u00f6lu", "english": "this house is not for sale", "french": "cette maison n'est pas \u00e0 vendre", "greynir": [{ "text": "\u00feetta", "lemma": "\u00feessi", "terminal": "fn_et_nf_hk", "pos": "fn" }, { "text": "h\u00fas", "lemma": "h\u00fas", "terminal": "no_et_nf_hk", "pos": "no" }, { "text": "er", "lemma": "vera", "terminal": "so_0_et_p3", "pos": "so" }, { "text": "ekki", "lemma": "ekki", "terminal": "ao", "pos": "ao" }, { "text": "til", "lemma": "til", "terminal": "fs_ef", "pos": "fs" }, { "text": "s\u00f6lu", "lemma": "sala", "terminal": "no_et_ef_kvk", "pos": "no", "hide": true }], "dict": 1 },
    { "id": 1745, "icelandic": "er hann a\u00f0 drekka kaffi?", "english": null, "french": "boit-il du caf\u00e9 ?", "greynir": [{ "text": "er", "lemma": "vera", "terminal": "so_0_et_p3", "pos": "so" }, { "text": "hann", "lemma": "hann", "terminal": "pfn_kk_et_nf", "pos": "pfn" }, { "text": "a\u00f0", "lemma": "a\u00f0", "terminal": "nhm", "pos": "nhm" }, { "text": "drekka", "lemma": "drekka", "terminal": "so_1_\u00fef_nh", "pos": "so" }, { "text": "kaffi", "lemma": "kaffi", "terminal": "no_et_\u00fef_hk", "pos": "no", "hide": true }], "dict": 1 },
    { "id": 1228, "icelandic": "\u00e9g byrja \u00e1 morgun", "english": "I start tomorrow", "french": "je commence demain", "greynir": [{ "text": "\u00e9g", "lemma": "\u00e9g", "terminal": "pfn_et_nf", "pos": "pfn" }, { "text": "byrja", "lemma": "byrja", "terminal": "so_0_et_p1", "pos": "so" }, { "text": "\u00e1 morgun", "lemma": "\u00e1 morgun", "terminal": "ao", "pos": "ao", "hide": true }], "dict": 0 },
    { "id": 177, "icelandic": "John er a\u00f0 gl\u00edma vi\u00f0 Tom", "english": "John is wrestling with Tom", "french": "John combat Tom", "greynir": [{ "text": "John", "lemma": "John", "terminal": "person_nf_kk", "pos": "person" }, { "text": "er", "lemma": "vera", "terminal": "so_0_et_p3", "pos": "so" }, { "text": "a\u00f0", "lemma": "a\u00f0", "terminal": "nhm", "pos": "nhm" }, { "text": "gl\u00edma", "lemma": "gl\u00edma", "terminal": "so_0_nh", "pos": "so", "hide": true }, { "text": "vi\u00f0", "lemma": "vi\u00f0", "terminal": "fs_\u00fef", "pos": "fs" }, { "text": "Tom", "lemma": "Tom", "terminal": "person_\u00fef_kk", "pos": "person" }], "dict": 0 },
    { "id": 908, "icelandic": "er \u00fea\u00f0 n\u00e6rri h\u00fasinu \u00fe\u00ednu?", "english": "is it near your house?", "french": "est-ce pr\u00e8s de chez toi ?", "greynir": [{ "text": "er", "lemma": "vera", "terminal": "so_0_et_p3", "pos": "so" }, { "text": "\u00fea\u00f0", "lemma": "\u00fea\u00f0", "terminal": "pfn_hk_et_nf", "pos": "pfn" }, { "text": "n\u00e6rri", "lemma": "n\u00e6rri", "terminal": "fs_\u00fegf", "pos": "fs" }, { "text": "h\u00fasinu", "lemma": "h\u00fas", "terminal": "no_et_\u00fegf_hk", "pos": "no", "hide": true }, { "text": "\u00fe\u00ednu", "lemma": "\u00feinn", "terminal": "fn_et_\u00fegf_hk", "pos": "fn" }], "dict": 0 }
  ];
  let idx = helpers.randomInteger(0, sentences.length - 1);
  return sentences[idx];
/*
  const sentence = await axios.get('http://localhost:82/groopy/sentences?anonymize');
  return sentence.data[0];
*/
}

export default new Vuex.Store({
  state: {
    game: {},
    gameSrcLang: undefined,
    gameTargetLang: undefined,
    gameAllowedErrors: 0,
    gameCount: 0,
    gameSuccess: 0,
    vocabulary: {},
    analysis: {},
    categories: [],
    wordsOfCategory: {},
    selectedWords: [],
    lastFailedWord: undefined,
    gameSentence: undefined,
  },
  getters: {
    game: (state) => { return state.game; },
    gameSrcLang: (state) => { return state.gameSrcLang; },
    gameTargetLang: (state) => { return state.gameTargetLang; },
    gameAllowedErrors: (state) => { return state.gameAllowedErrors },
    gameCount: (state) => { return state.gameCount; },
    gameSuccess: (state) => { return state.gameSuccess; },
    gameFailure: (state) => { return state.gameCount - state.gameSuccess; },
    vocabulary: (state) => { return state.vocabulary; },
    analysis: (state) => { return state.analysis; },
    categories: (state) => { return state.categories; },
    selectedCategories: (state) => { return state.categories.filter((entry) => entry.selected); },
    selectedWords: (state) => { return state.selectedWords; },
    lastFailedWord: (state) => { return state.lastFailedWord; },
    shuffledSelectedWords: (state) => { let clone = state.selectedWords.slice(0); helpers.shuffleArray(clone); return clone; },
    gameSentence: (state) => { return state.gameSentence; },
  },
  mutations: {
    /*async*/ VOCABULARY(state, data) {
      state.vocabulary = data.vocabulary;
      state.analysis = data.analysis;

      let sc = localStorage.getItem("selectedCategories");
      let selectedCategories = sc ? sc.split(":") : [];

      state.categories = data.categories.map((entry) => {
        let selected = selectedCategories.includes(entry);
        return { category: entry, selected };
      });

      state.wordsOfCategory = {};
      for (const [category, wordsOfCategory] of Object.entries(
        data.wordsOfCategories
      )) {
        let array = [];
        wordsOfCategory.forEach((word) => {
          Object.entries(word).forEach((arr) => {
            array.push({ is: arr[0], fr: arr[1] });
          });
        });

        state.wordsOfCategory[category] = array;
      }
      // for (const category of data.categories) {
      //   let wordsOfCategory = [];
      //   data.wordsOfCategories.forEach((word) => {
      //     Object.entries(word).forEach((arr) => {
      //       wordsOfCategory.push({ is: arr[0], fr: arr[1] });
      //     });
      //   });
      //   state.wordsOfCategory[entry.category] = wordsOfCategory;
      // }

      /*await*/ newWords(state);
    },
    /*async*/ CATEGORY_SELECTED(state, entry) {
      let selectedCategories;

      if (entry) {
        let category = state.categories.find(
          (e) => e.category === entry.category
        );
        if (category) {
          category.selected = entry.selected;
        }
        selectedCategories = state.categories
          .filter((e) => e.selected)
          .map((e) => e.category)
          .join(":");
      } else {
        state.categories.forEach((e) => (e.selected = false));
        selectedCategories = [];
      }

      localStorage.setItem("selectedCategories", selectedCategories);

      newGame(state);
      /*await*/ newWords(state);
    },
    /*async*/ NEW_GAME(state) {
      newGame(state);
      /*await*/ newWords(state);
    },
    FAILED_WORD(state, word) {
      if (state.failedWord) {
        delete state.failedWord.failed;
      }

      state.failedWord = word;

      if (state.failedWord) {
        state.failedWord.failed = true;
      }
    },
    END_GAME(state, success) {
      if (success) {
        state.gameSuccess++;
      }
    },
  },
  actions: {
    // TODO https://wildermuth.com/2019/04/22/Vuex-and-Asynchronicity
    /*async*/ init({ commit, state }) {
      try {
        /*await*/ vocabularyService.init();
        commit("VOCABULARY", {
          vocabulary: vocabularyService.getVocabulary(),
          analysis: vocabularyService.getAnalysis(),
          categories: vocabularyService.getCategories(),
          wordsOfCategories: vocabularyService.getWordsOfCategories(),
        });

        commit("NEW_GAME");
      } catch (error) {
        console.log(error);
      }
    },
    categorySelected({ commit, state }, entry) {
      if (entry) {
        console.log("category: " + JSON.stringify(entry));
      } else {
        console.log("no category");
      }
      commit("CATEGORY_SELECTED", entry);
    },
    newGame({ commit, state }) {
      commit("NEW_GAME");
    },
    failedWord({ commit, state }, failedWord) {
      commit("FAILED_WORD", failedWord);
    },
    incrementSuccess({ commit, state }) {
      commit("END_GAME", 1);
    },
    incrementFailure({ commit, state }) {
      commit("END_GAME", 0);
    },
  },
  modules: {},
});
